import React, { KeyboardEvent } from 'react';

export interface NotificationCardProps {
  id?: string | number;
  unread?: boolean;
  label?: string;
  message?: string;
  senderPictureUrl?: string;
  onSelect: () => void;
}

export const NotificationCard = ({
  id,
  unread = false,
  label,
  message,
  senderPictureUrl,
  onSelect,
}: NotificationCardProps): JSX.Element => {
  const handleKeyDown = (e: KeyboardEvent<HTMLDivElement>): void => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      onSelect();
    }
  };

  return (
    <div
      id={id !== undefined ? `notification-card-${id}` : undefined}
      tabIndex={0}
      role='button'
      onClick={onSelect}
      onKeyDown={handleKeyDown}
      className={
        'rounded-lg p-4 cursor-pointer transition-colors mb-3 border-2 '
        + 'hover:border-sapphire-100 focus:outline-none focus:border-sapphire-100 '
        + 'active:border-sapphire '
        + (unread
          ? 'bg-sapphire-50/40 border-sapphire-50 border-l-4 border-l-sapphire'
          : 'bg-white border-sapphire-50')
      }
    >
      <div className='flex items-start justify-between gap-4'>
        <div className='flex-1'>
          <div className='flex items-center gap-2 mb-1'>
            {unread && (
              <span
                aria-label='Unread'
                className='inline-block w-2 h-2 rounded-full bg-sapphire'
              />
            )}
            {label && (
              <h5 className='text-xs text-neutral-600 mb-0 font-normal'>
                {label}
              </h5>
            )}
          </div>
          {message && (
            <p className={`text-base mb-0 ${unread ? 'font-semibold' : ''}`}>
              {message}
            </p>
          )}
        </div>
        {senderPictureUrl && (
          <img
            src={senderPictureUrl}
            alt=''
            className='w-10 h-10 rounded-full object-cover flex-shrink-0'
          />
        )}
      </div>
    </div>
  );
};
